export class TagFamily {
    id: number;
    name: string;
}



// WEBPACK FOOTER //
// ./src/app/_models/tagFamily.ts